// extracted by mini-css-extract-plugin
module.exports = {"AuthPage":"AuthPage_AuthPage__2oFdj"};